import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'

// Token stored in memory with localStorage backup for persistence across refreshes
const STORAGE_KEY = 'auth_token'
let _token: string | null = localStorage.getItem(STORAGE_KEY)

export function setToken(token: string | null) {
  _token = token
  if (token) {
    localStorage.setItem(STORAGE_KEY, token)
  } else {
    localStorage.removeItem(STORAGE_KEY)
  }
}

export function getToken(): string | null {
  return _token
}

const httpLink = createHttpLink({
  uri: '/graphql',
})

const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      authorization: _token ? `Bearer ${_token}` : '',
    },
  }
})

export const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
})
